import * as highcharts from "highcharts";
import { map } from "lodash";
import { SnapshotCompareOutput } from "../../cpr-snapshot-compare/model";

export function getSeries(
  data: SnapshotCompareOutput,
  titlePhotoOne: string,
  titlePhotoTwo: string
) {
  return map(data, v =>
    buildEntrySerie(v.key.toString(), v.value, titlePhotoOne, titlePhotoTwo)
  );
}

export function getOptions(values: any) {
  return {
    chart: {
      type: "waterfall",
    },
    credits: {
      enabled: false,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        dashStyle: "Dot",
        dataLabels: {
          enabled: true,
          formatter(this: any) {
            return highcharts.numberFormat(this.y / 1000, 0, ".", ",") + " K€";
          },
          stroke: "grey",
          style: {
            color: "black",
            fontWeight: "bold",
          },
          verticalAlign: "top",
          y: -30,
        },
      },
    },
    series: [
      {
        data: values,
        name: undefined,
      },
    ],
    title: {
      text: "",
    },
    tooltip: {
      pointFormatter(this: any) {
        return `<span style="color:{black}">NBI</span>: ${highcharts.numberFormat(
          this.y / 1000,
          0,
          ".",
          ","
        )} K€ </b>`;
      },
    },
    xAxis: {
      labels: {
        style: {
          color: "#777777",
          fontSize: "14px",
        },
      },
      lineColor: "#777777",
      type: "category",
    },
    yAxis: {
      labels: {
        formatter(this: any) {
          return formatYvaluesAxis(this.value);
        },
        style: {
          color: "#777777",
          fontSize: "14px",
        },
      },
      lineColor: "#777777",
      lineWidth: 1,
      title: {
        text: "NBI",
      },
    },
  };
}

function buildEntrySerie(
  key: string,
  value: number,
  titlePhotoOne: string,
  titlePhotoTwo: string
) {
  let data: any;
  data = { ...data, name: key, y: value };

  switch (data.name) {
    case "Total photo 1":
      data = {
        ...data,
        color: "#444852",
        name: `Total NBI Photo 1 (${titlePhotoOne})`,
      };
      break;
    case "Total photo 2":
      data = {
        ...data,
        color: "#444852",
        isSum: true,
        name: `Total NBI Photo 2 (${titlePhotoTwo})`,
      };
      break;
    case "New LE":
    case "New clients":
    case "NBI Increase":
      data = {
        ...data,
        color: "#41c49d",
        name: data.name,
      };
      break;
    case "Exited clients":
    case "Exited LE":
    case "NBI Decrease":
      data = {
        ...data,
        color: "#dc4941",
        name: data.name,
      };
      break;
  }
  return data;
}

function formatYvaluesAxis(value: any) {
  if (value >= 1000 && value <= 999999) {
    return (value / 1000).toString() + " K";
  }
  if (value >= 1000000 && value <= 999999999) {
    return (value / 1000000).toString() + " Mln";
  }
  if (value >= 1000000000 && value <= 999999999999) {
    return (value / 1000000000).toString() + " Bln";
  }
  return "";
}
